export default "__VITE_ASSET__BQSCkDac__"